import React from "react";
import { useTranslation } from "react-i18next";

import { IHttpRequestConfig } from "@/browser";
import { ITypeaheadProps, Typeahead } from "@/components/Typeahead";
import {
  fetchLocationsHints,
  IFetchLocationsHintsSearch,
  ILocation,
  ILocationGroup,
  ILocationGrouped,
} from "@/data/locations";
import { SelectComponents, typeaheadFactory } from "@/eworkitComponents";

const TypeaheadLocation: React.FC<ITypeaheadProps<ILocation> & IFetchLocationsHintsSearch> = React.memo(
  ({ components, ...restProps }) => {
    const { t } = useTranslation("session");
    return (
      <Typeahead
        placeholder={t("COMPONENTS.TYPEAHEAD_LOCATION.PLACEHOLDER")}
        components={{ ...components, SingleValue }}
        {...restProps}
      />
    );
  },
);

const SingleValue = (props: any) => (
  <SelectComponents.SingleValue {...props}>{props.data.city || props.data.name}</SelectComponents.SingleValue>
);

const fetchLocationsHintsProxy = async (query: IFetchLocationsHintsSearch, options: IHttpRequestConfig) => {
  return fetchLocationsHints(query, options);
};

export const TypeaheadLocationHints = typeaheadFactory<
  ITypeaheadProps,
  ILocationGrouped | ILocationGroup,
  IFetchLocationsHintsSearch
>(fetchLocationsHintsProxy, TypeaheadLocation);
